import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { nameToId } from '../utils/imageUtils';

export function useWorkNavigation() {
  const navigate = useNavigate();

  const navigateToWork = useCallback((workName: string) => {
    navigate('/work/' + nameToId(workName));
  }, [navigate]);

  return navigateToWork;
}